var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLouceng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4120_18704)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 16,
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    width: 1,
    height: 16,
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 14,
    height: 5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 7,
    width: 14,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 6,
    width: 14,
    height: 1,
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 11,
    width: 14,
    height: 1,
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 11,
    width: 14,
    height: 5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 4.5,
    width: 15,
    height: 7,
    fill: "white",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4120_18704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLouceng);
export default __webpack_public_path__ + "static/media/louceng.bd5e944e831bb946727efbf66e4e85cd.svg";
export { ForwardRef as ReactComponent };